import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { User, Heart, Shield, Users, Brain, ArrowRight } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    id: 'individual',
    title: 'Individual Counselling & Therapy',
    description: 'Personalized one-on-one therapy sessions to help you work through PTSD, anxiety, depression, grief, and life transitions.',
    icon: User
  }, {
    id: 'couples',
    title: 'Couples Therapy',
    description: 'Strengthen your relationship through improved communication, conflict resolution, and deeper emotional connection.',
    icon: Heart
  }, {
    id: 'family',
    title: 'Family Therapy',
    description: 'Address family dynamics, improve communication patterns, and heal relationships. Navigate parenting challenges.',
    icon: Users
  }, {
    id: 'trauma',
    title: 'Trauma Therapy',
    description: 'Evidence-based trauma-focused therapy to help you process and heal from traumatic experiences and reduce PTSD symptoms.',
    icon: Shield
  }, {
    id: 'emdr',
    title: 'EMDR Therapy',
    description: 'Eye Movement Desensitization and Reprocessing — a powerful therapy that helps the brain process disturbing memories.',
    icon: Brain
  }];
  return <section id="services" className="py-12 lg:py-16 bg-olive" data-id="element-493">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-494">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-495">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-496">
            Counselling Services
          </h2>
          <p className="text-white/70 text-base font-medium" data-id="element-497">
            Comprehensive therapeutic support tailored to your unique needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-498">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={service.id} className={index === 4 ? 'sm:col-span-2 lg:col-span-1' : ''} data-id="element-499">
                <Link to={`/services/${service.id}`} className="group block bg-white/10 backdrop-blur border border-white/15 rounded-xl p-5 transition-all duration-300 hover:bg-white h-full" data-id="element-500">
                  <div className="w-10 h-10 rounded-lg bg-white/15 text-white flex items-center justify-center mb-4 group-hover:bg-olive group-hover:text-white transition-colors" data-id="element-501">
                    <Icon size={22} strokeWidth={1.5} data-id="element-502" />
                  </div>
                  <h3 className="font-heading text-base font-bold text-white mb-2 group-hover:text-charcoal transition-colors" data-id="element-503">
                    {service.title}
                  </h3>
                  <p className="text-white/70 text-sm mb-4 font-medium group-hover:text-charcoal/70 transition-colors line-clamp-2" data-id="element-504">
                    {service.description}
                  </p>
                  <div className="flex items-center text-white/60 font-bold group-hover:text-olive transition-colors text-xs uppercase tracking-wide" data-id="element-505">
                    Learn more
                    <ArrowRight size={14} className="ml-1.5 group-hover:translate-x-1 transition-transform" data-id="element-506" />
                  </div>
                </Link>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-507">
          <Link to="/services" className="inline-flex items-center justify-center bg-white text-olive px-6 py-3 rounded-full font-bold text-base transition-all hover:bg-cream min-h-[48px] tracking-wide" data-id="element-508">
            View All Services
            <ArrowRight size={16} className="ml-2" data-id="element-509" />
          </Link>
        </div>
      </div>
    </section>;
}